import { LOADING, PUBLIC_MEETING_LINKS } from "../actionType/publicMeetingLinkType";

const initialState = {
  loading: false,
  publicMeetingLinks: [],
};

const publicMeetingLinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case PUBLIC_MEETING_LINKS:
      return {
        ...state,
        publicMeetingLinks: action.payload,
      };
    default:
      return state;
  }
};
export default publicMeetingLinkReducer;